'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var labels = {
  prev: 'Previous',
  next: 'Next'
};

var PaginationLink = function PaginationLink(_ref) {
  var classNames = _ref.classNames,
      currentSlide = _ref.currentSlide,
      direction = _ref.direction,
      disabled = _ref.disabled,
      icon = _ref.icon,
      onClick = _ref.onClick,
      size = _ref.size,
      slideCount = _ref.slideCount,
      styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ['classNames', 'currentSlide', 'direction', 'disabled', 'icon', 'onClick', 'size', 'slideCount', 'styles']);

  return _react2.default.createElement(
    'button',
    _extends({
      'aria-label': labels[direction],
      type: 'button',
      role: 'button',
      disabled: disabled,
      onClick: onClick,
      onKeyDown: onClick,
      className: 'c11n-pagination-link ' + classNames.root
    }, props),
    _react2.default.createElement(_icon2.default, { name: icon, rotate: direction === 'prev' ? 180 : 0, size: size })
  );
};

PaginationLink.propTypes = {
  /**
   * The current slide if in a Carousel
   */
  currentSlide: _propTypes2.default.number,

  /**
   * The direction of the arrow
   */
  direction: _propTypes2.default.oneOf(['prev', 'next']).isRequired,

  /**
   * Whether or not the link is disabled
   */
  disabled: _propTypes2.default.bool,

  /**
   * The name of the icon e.g. chevron, heart etc.
   */
  icon: _propTypes2.default.string,

  /**
   * onClick handler
   */
  onClick: _propTypes2.default.func,

  /**
   * The icon size
   */
  size: _propTypes2.default.number,

  /**
   * The total number of slides if in a Carousel
   */
  slideCount: _propTypes2.default.number
};

PaginationLink.defaultProps = {
  direction: 'next',
  icon: 'chevron',
  size: 1
};

exports.default = (0, _withStyles2.default)(_styles2.default)(PaginationLink);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/pagination-link/index.js
// module id = 150
// module chunks = 0